// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../.yarn/__virtual__/css-loader-virtual-2ae40ad6f9/0/cache/css-loader-npm-3.5.3-0f886851e6-e5fa1707d7.zip/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customer-part-number-outer-wrapper{display:flex;flex-direction:column;justify-content:center;padding:5px;width:100%}.customer-part-number-outer-wrapper .field-wrapper{display:flex;flex-direction:row;flex:2;padding:5px}.customer-part-number-outer-wrapper .label{font-size:1rem;font-weight:500;min-width:100px;text-align:right;white-space:nowrap;margin:5px 5px 0 0}\n", ""]);
// Exports
module.exports = exports;
